import {AxiosResponse} from "axios";
import {PuzzleRecordHelper} from "platform_common/types/data/PuzzleRecord";
import {UI} from "../ui/UI";

import * as Debug from 'debug';
import {CAPIExternalPuzzle} from "./api/CAPIExternalPuzzle";
import {JAPIExternalPuzzleGetRecordResponse} from "platform_common/types/api/JAPIExternalPuzzle";

let debug:Debug.IDebugger = Debug.debug('vgift.com:libs:PuzzleInfo');

/**
 * Class to facilitate all interaction with puzzle information in the app.
 */
export class PuzzleInfo {

    /**
     * Get record for specific id
     *
     * @param id
     */
    public static async getRecordAndPopulate(id:number):Promise<void> {

        // get all records
        let getRecordResult:AxiosResponse<JAPIExternalPuzzleGetRecordResponse> = await CAPIExternalPuzzle.getRecord(id) as any;

        // ret record in UI
        UI.P_STORE.setPuzzleRecord(PuzzleRecordHelper.JToI(getRecordResult.data.record));
    }
}
